import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { DISPLAY_REM } from 'Components/frameworks/image/constants';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Image } from 'Components/frameworks/image/Image';
import { asRatioDisplay } from 'Src/types/cast-helpers';
type Props = {
  itemTitle: string;
  link?: string;
  mediaUrl: string;
};
const IMG_DIMENSIONS = {
  h: 313,
  w: 240,
};
const RATIO_DISPLAYS = [
  {
    value: 1 / 6,
    unit: DISPLAY_REM,
  },
  {
    value: 180,
    unit: 'px',
  },
  {
    value: 240,
    unit: 'px',
  },
  {
    value: 240,
    unit: 'px',
  },
];
export const ThematicCard = ({ itemTitle, link, mediaUrl }: Props) => {
  const track = useTracking();
  const thematicTitle = itemTitle || '';
  const trackingData = {
    actionGA: 'push_content_thematic',
    labelGA: `${thematicTitle}`.trim(),
  };
  const TagName = link ? DynamicLink : 'div';
  const tagProps = link
    ? {
        url: link,
        onClick: () => track(trackingData),
      }
    : {};
  return (
    <TagName
      {...tagProps}
      className="group relative isolate flex h-[313px] w-240 shrink-0 items-end justify-center overflow-hidden rounded-12 p-10 py-25 text-center md:h-[235px] md:w-180"
      data-testid="ThematicLine-item"
    >
      <Image
        altMsg=""
        dimensions={IMG_DIMENSIONS}
        className={classnames('absolute inset-0', {
          'transition-transform transform duration-250 ease-in group-hover:scale-105 group-focus:scale-105':
            link,
        })}
        imageUrl={mediaUrl}
        ratioDisplay={asRatioDisplay(RATIO_DISPLAYS)}
      />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_50%,rgba(0,0,0,0.4)_100%)]" />
      <p className="relative font-brand text-20 font-bold leading-tight text-white">{itemTitle}</p>
    </TagName>
  );
};
